import { http } from "@/http";

export default {
  uploadCreps(payload) {
    return http.post('/api/v1/payment-batch/upload/creps', payload)
  }
};
